module.exports = __webpack_public_path__ + "static/media/institutions-landscape.95b7715b.jpg";